import { EventEmitterStatic } from "base/EventEmitter";
import Page from "webPage/Page";
import $ from "jquery";
import PromiseHelper from "base/PromiseHelper";

class AjaxPageLoader extends EventEmitterStatic {

    static init(settings = {}) {
        this.settings = $.extend({}, this.DEFAULT_SETTINGS, settings);
        this.is_hash_change = false;
        this.bind_events();

        return this;
    }

    static bind_events() {
        $("body").on("click", "a[href]", function (e) {
            let href = $(this).attr("href");

            if (/^#/.test(href)) {
                // Clicking on a hash link fires a popstate event. We need to ignore it
                AjaxPageLoader.is_hash_change = true;
                return true;
            }
            if (e.ctrlKey || ["http:", "https:"].indexOf(this.protocol) === -1 || this.host !== window.location.host || $(this).is("[target='_blank']") || $(this).is(".js-no-ajax-load")) {
                return true;
            }

            AjaxPageLoader.load_page(href);

            return false;
        });

        window.onhashchange = (e) => {
            this.is_hash_change = false;
        };
        window.onpopstate = (e) => {
            if (this.is_hash_change) return;
            this.load_page(window.location.pathname, false);
        };
    }

    static load_page(url, doPush = true) {
        console.log("Ajax loading ", url);

        if (this.emit("beforeLoading", {url: url}) === false) {
            // Event cancelled. Load normally
            window.location.href = url;
            return;
        }

        this.emit("loading", {url: url});

        if ("undefined" !== typeof AjaxPageLoader.loadRequest) {
            AjaxPageLoader.loadRequest.abort();
        }

        let response = AjaxPageLoader.get_html(url);

        AjaxPageLoader.loadRequest = response.request;

        response.request.then(() => {
            // Use the returned responseURL, this handles redirects nicely
            if ("string" === typeof response.xhr.responseURL) {
                let a = document.createElement("a");
                a.href = response.xhr.responseURL;
                url = a.pathname + a.search + a.hash;
            }
            if (doPush && this.emit("pushState", {url: url}) !== false) {
                history.pushState({}, "", url);
            }
        });

        PromiseHelper.delayed_promise(response.request, this.settings.minimumLoadTime).then((data) => {
            let $html = AjaxPageLoader.parse_html(data);
            this.emit("htmlLoaded", {
                url: url,
                html: $html,
            });
            this.handle_html(url, $html);
        }).catch((e) => {
            if (e === "abort") return;
            console.error("Couldn't ajax load page ", url, e);
            window.location.href = url;
        });
    }

    static get_html(url) {
        let res = {xhr: null};

        res.request = $.ajax({
            method: "GET",
            url: url,
            xhr: function () {
                return res.xhr = $.ajaxSettings.xhr.apply(this, arguments);
            },
        });

        return res;
    }

    static parse_html(html) {
        let dom = (new DOMParser()).parseFromString(html, "text/html");
        return $(dom);
    }

    static handle_html(url, $html) {

        let $content = $html.find(this.settings.wrapperElement);
        if ($content.length === 0) {
            $content = $html.filter(this.settings.wrapperElement);
        }

        if ($content.length === 0) {
            console.error("Missing ajax content");
            window.location.href = url;
            return;
        }

        let $currentContent = $(this.settings.wrapperElement);
        if ($currentContent.length === 0) {
            console.error("Missing current ajax content");
            window.location.href = url;
            return;
        }
        Page.unloadPage();

        this.emit("contentLoaded", {content: $content});

        $currentContent.replaceWith($content);

        let bodyClassesEvent = {
            url: url,
            html: $html,
            classes: $html.find("body").attr("class"),
        };
        this.emit("bodyClasses", bodyClassesEvent);
        $("body").attr("class", bodyClassesEvent.classes);

        let headElements = ["title", "meta"];
        let $head = $("head");
        $head.find(headElements.join(",")).remove();
        headElements.forEach((elementName) => {
            $head.append($(elementName, $html));
        });

        AjaxPageLoader.fix_html($content);

        $("body,html").scrollTop(0);

        this.emit("contentAdded", {content: $content});

        Page.handlePage();
        $("body,html").trigger("scroll");

        this.emit("finished");
    }

    static fix_html($content) {
        // Fix SVGs not being rendered on chrome
        $content.find("svg use").each(function (_, el) {
            let $el = $(el);
            let $svg = $el.parent();

            $svg.before("<svg " + ($svg.is("[class]") ? "class=\"" + $svg.attr("class") + "\"" : "") + "><use xmlns:xlink=\"http://www.w3.org/1999/xlink\" xlink:href=\"" + $el.attr("xlink:href") + "\"></use></svg>");
            $svg.remove();
        });

        // Fix images with srcset not having a height on safari - https://stackoverflow.com/questions/45487105/ajax-loaded-images-in-safari-not-respecting-srcset
        if (/Version\/11/.test(navigator.userAgent) || /iPad; CPU OS 11/.test(navigator.userAgent)) {
            $content.find("img[srcset]").each((_, el) => {
                el.outerHTML = el.outerHTML;
            });
        }

        $content.find("noscript").remove();
    }

    /*IE 10 Polyfills*/
    static _init() {
        return super._init.apply(this, arguments);
    }

    static on(event, fn) {
        return super.on.apply(this, arguments);
    }

    static off(event, fn) {
        return super.off.apply(this, arguments);

    }

    static emit(event, data) {
        return super.emit.apply(this, arguments);

    }

    static destroy() {
        super.destroy.apply(this, arguments);
    }

    static pipe(emitter) {
        super.pipe.apply(this, arguments);
    }
}

AjaxPageLoader.DEFAULT_SETTINGS = {
    minimumLoadTime: 0,
    wrapperElement: ".ajax-container",
};

export default AjaxPageLoader;
